import React, { useState, useEffect } from "react";
import { useRecordContext } from "react-admin";
import { authClient } from "../server";

export const TranscodingStatus = () => {
  const record = useRecordContext();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activities, setActivities] = useState(null);

  /** Heartbeat payload is Base64-encoded JSON */
  const ffmpegActivitiy = activities?.find(
    (pendingActivity) => pendingActivity.activityType.name === "ffmpeg",
  );
  const isTranscoding = !!ffmpegActivitiy;
  const base64HeartbeatPayload =
    ffmpegActivitiy?.heartbeatDetails?.payloads[0].data || btoa("null");
  const heartbeatData = JSON.parse(atob(base64HeartbeatPayload));
  const progressString = `${((heartbeatData?.progressRatio || 0) * 100).toFixed(2)}%`;

  useEffect(() => {
    if (!record || !record.lecture_id) return;

    const fetchStatus = async () => {
      try {
        const response = await authClient.get(
          `/temporal/workflows/x/LectureTranscoding-${record.lecture_id}`,
        );
        if (response?.json) {
          setActivities(response.json.raw.pendingActivities);
        } else {
          setError("No data available");
        }
      } catch (err) {
        console.error("Error fetching transcoding status:", err);
        setError(`Error: ${err.message || "Failed to fetch status"}`);
      }
      setIsLoading(false);
    };

    setIsLoading(true);
    fetchStatus();
  }, [record]);

  if (isLoading) {
    return <>Loading...</>;
  }
  if (error) {
    return <div style={{ color: "red" }}>{error}</div>;
  }
  if (!isTranscoding) {
    return <>{activities?.[0]?.activityType.name || "-"}</>;
  }

  return <>{progressString}</>;
};
